module.exports = __webpack_public_path__ + "assets/img/2-1.48667c1d.png";